import updateChildrenPresence from '../utils/helpers/update-children-presence';
import instance from '../instance';
import getUniquePresenceUpdates from '../utils/helpers/get-unique-presence-updates';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const bulkSetChildrenPresence = (element, childrenPresenceUpdates) => {
  const uniquePresenceUpdates = getUniquePresenceUpdates(childrenPresenceUpdates);

  uniquePresenceUpdates.forEach((childrenPresenceUpdate) => {
    const { childrenSelector, enabled, blockSettingId } = childrenPresenceUpdate;
    updateChildrenPresence(element, childrenSelector, enabled, blockSettingId);
  });

  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);
  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default bulkSetChildrenPresence;
